import { z } from 'zod';
import { isValidTtsVoice } from './tts-voices.js';
/**
 * MessageTemplate — reusable template for voice / SMS / email content.
 * Referenced by Events and Campaigns. Variable interpolation
 * (e.g., `{{first_name}}`) happens at delivery time.
 */
export const MessageTemplateSchema = z.object({
    id: z.string().regex(/^tpl_[A-Za-z0-9_-]+$/),
    customer_id: z.string().regex(/^cust_[A-Za-z0-9_-]+$/),
    name: z.string().min(1).max(120),
    tts_voice: z
        .string()
        .optional()
        .refine((v) => v == null || v === '' || isValidTtsVoice(v), {
        message: 'Unknown TTS voice — must be one of the supported PBX voices',
    }),
    /** Played first during voice reminders / AI messages. */
    intro_voice_message: z.string().optional(),
    /** Played last during voice reminders / AI messages. */
    closing_voice_message: z.string().optional(),
    /** If true, voice flow asks the recipient to confirm identity before message playback. */
    confirm_identity: z.boolean().default(false),
    /** SMS body. Hard cap 1600 chars (10 SMS segments) — providers will reject above this. */
    sms_body: z.string().max(1600).optional(),
    email_subject: z.string().max(998).optional(),
    email_body: z.string().optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const MessageTemplateCreateSchema = MessageTemplateSchema.omit({
    id: true,
    customer_id: true,
    created_at: true,
    updated_at: true,
});
//# sourceMappingURL=templates.js.map